<template>
    <div class="side-center">
        <div class="side">

        <!--

            <ul>
                <router-link :to="{name: 'vacanciestd'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>Торговый дом</span></a></router-link>

                <router-link :to="{name: 'vacanciesvgg'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"

                ><a><span>ООО ВГГ</span></a></router-link>

                <router-link :to="{name: 'vacanciesrh'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>Управляющая компания</span></a></router-link>

                <router-link :to="{name: 'vacancieslog'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>Ренна Логистик</span></a></router-link>

                <router-link :to="{name: 'vacanciesdist'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>Ренна Дистрибуция</span></a></router-link>

                <router-link :to="{name: 'vacanciesamkk'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>АМКК</span></a></router-link>

                <router-link :to="{name: 'vacanciessov'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"

                ><a><span>ООО Советское</span></a></router-link>

                <router-link :to="{name: 'vacancieskmkk'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>КМКК</span></a></router-link>

                <router-link :to="{name: 'vacanciesfnm'}"
                             active-class="current"
                             tag="li"
                             class="nav-child-item"
                ><a><span>ФабНМ</span></a></router-link>

            </ul>
        -->

        </div>
    </div>
</template>

<script>
    export default {
        name: "SideVacancies"
    }
</script>